// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"160":"3ca80ffd","487":"3eabb6e8","690":"abaa4197","719":"3d34e8c2","862":"3667f41d"}[chunkId] + ".js";
};